<template>
  <div class="guide-box flex flex-center">
    <div class="main-box flex flex-col">
      <div class="title-box">
        {{ fileType === 1 ? "申 报 指 南" : "文 件 下 载" }}
      </div>
      <div class="content-box flex-1">
        <div
          class="item-box flex align-items-center"
          v-for="(item, index) in fileList"
          :key="index"
        >
          <img class="img-box" :src="getImg(item.fileType)" alt="" />
          <div class="info-box flex-1">
            <div>{{ item.name }}</div>
            <div>{{ item.byte }}</div>
          </div>
          <div
            v-if="fileType == 1"
            class="preview-btn"
            @click="preview(item.name)"
          >
            <span class="preview">预 览</span>
          </div>
          <div class="download-btn">
            <span><a @click="download(item.name)">下 载</a></span>
            <!-- <span
              ><a
                v-if="fileType == 1"
                :href="`${path}${getFileName(
                  $store.state.region
                )}职业院校铸魂育人计划项目遴选-学校使用手册.pdf`"
                download
                >下 载</a
              ></span
            > -->
            <!-- <span
              ><a v-if="fileType == 2" @click="download(item.name)"
                >下 载</a
              ></span
            > -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { baseURL } from "@/utils/request.js";
export default {
  name: "",
  components: {},
  props: {
    fileType: {
      type: Number,
      default: 1,
    },
    fileList: Array,
  },
  data() {
    return {
      path: baseURL,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    getFileName(type) {
      if (type === 1) {
        return "吕梁市";
      } else if (type === 2) {
        return "临汾市";
      } else {
        return "长治市";
      }
    },
    getImg(type) {
      if (type === 1) {
        // pdf
        return require("../assets/images/img3.png");
      } else {
        // word
        return require("../assets/images/img2.png");
      }
    },
    preview(name) {
      window.open(`${this.path}${name}`, "_blank");
      // if (this.$store.state.region === 1) {
      //   window.open(
      //     `${this.path}吕梁市职业院校铸魂育人计划项目遴选-学校使用手册.pdf`,
      //     "_blank"
      //   );
      // } else if (this.$store.state.region === 2) {
      //   window.open(
      //     `${this.path}临汾市职业院校铸魂育人计划项目遴选-学校使用手册.pdf`,
      //     "_blank"
      //   );
      // } else {
      //   window.open(
      //     `${this.path}长治市职业院校铸魂育人计划项目遴选-学校使用手册.pdf`,
      //     "_blank"
      //   );
      // }
    },
    download(name) {
      const a = document.createElement("a");
      // 给a标签的href属性值加上地址,注意:这里是绝对路径,不用加 点.
      a.href = `/${name}`;
      // 设置下载文件文件名,这里加上.xlsx指定文件类型,pdf文件就指定.fpd即可
      a.download = name;
      // 障眼法藏起来a标签
      a.style.display = "none";
      // 将a标签追加到文档对象中
      document.body.appendChild(a);
      // 模拟点击了<a>标签,会触发<a>标签的href的读取,浏览器就会自动下载了
      a.click();
      // 一次性的,用完就移除a标签
      a.remove();
      // window.open(`${this.path}${name}`, "_blank");
    },
  },
};
</script>

<style scoped lang="scss">
.main-box {
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
.title-box {
  height: 60px;
  line-height: 60px;
  font-size: 27px;
  font-family: Microsoft YaHei;
  text-align: center;
  font-weight: bold;
  background: #ffe4de;
  color: #000000;
}
.content-box {
  background: #fff;
  overflow: auto;
  padding: 33px 40px;
  padding-top: 10px;
}
.item-box {
  height: 84px;
  padding: 0 34px;
  margin-top: 23px;
  background: url("../assets/images/img15.png") no-repeat;
  background-size: 100% 100%;
}
.img-box {
  width: 52px;
  height: 52px;
}
.info-box {
  margin-left: 20px;
}
.info-box div:nth-child(1) {
  font-size: 19px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
}
.info-box div:nth-child(2) {
  font-size: 15px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #a28e8a;
}
.preview-btn {
  width: 100px;
  height: 33px;
  line-height: 33px;
  text-align: center;
  background: #ffaa97;
  border: 1px solid #ffaa97;
  font-size: 17px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #901d22;
  border-radius: 20px;
  margin-right: 20px;
}
.download-btn {
  width: 100px;
  height: 33px;
  line-height: 33px;
  text-align: center;
  background: #ffaa97;
  border: 1px solid #ffaa97;
  font-size: 17px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #901d22;
  border-radius: 20px;
  a {
    color: #901d22 !important;
  }
}
.preview-btn:hover {
  color: #ffffff !important;
  background: linear-gradient(to right, #b91000, #d41400);
  cursor: pointer;
}
.download-btn:hover {
  color: #ffffff !important;
  background: linear-gradient(to right, #b91000, #d41400);
  cursor: pointer;
  a {
    color: #ffffff !important;
  }
}
.item-box:hover {
  background: url("../assets/images/img12.png") no-repeat;
  background-size: 100% 100%;
}
</style>
